import { AbstractControl } from '@angular/forms';

export function passwordConfirmationValidator(comparableControl: AbstractControl) {
  return function(control: AbstractControl) {
    if (!comparableControl) {
      return null;
    }

    return control.value === comparableControl.value ? null : {passwordConfirmation: true};
  };
}
